import React from "react";
import { Eye } from "lucide-react";
import "./../styles/components/newsCard.css";
import { useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "../config/api";
import defaultThumbnail from "../assets/images/default-thumbnail.webp";

interface NewsCardProps {
  id?: string | number; // Giữ lại để tương thích, nhưng ưu tiên dùng slug
  slug: string;
  title: string;
  content: string;
  imageUrl: string;
  tag: string;
  views: number;
  currentPage?: number; // Thêm prop để truyền currentPage
}

const NewsCard: React.FC<NewsCardProps> = ({
  id,
  slug,
  title,
  content,
  imageUrl,
  tag,
  views,
  currentPage,
}) => {
  const navigate = useNavigate();
  
  const getDetailPath = (postSlug: string) => {
    return `/${postSlug}`;
  };

  // Hàm loại bỏ HTML tags và lấy text thuần
  const stripHtml = (html: string): string => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  // Lấy preview text (loại bỏ HTML và giới hạn độ dài)
  const getPreviewText = (htmlContent: string, maxLength: number = 150): string => {
    const text = stripHtml(htmlContent);
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength).trim() + "...";
  };

  // Scroll về đầu trang và điều hướng khi click vào link
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // Scroll về đầu trang ngay lập tức TRƯỚC KHI điều hướng
    window.scrollTo(0, 0);
    // Điều hướng ngay sau đó
    navigate(getDetailPath(slug), { state: { returnPage: currentPage } });
  };

  return (
    <div className="news-card">
      <div className="news-card-image">
        <span className="news-card-tag">{tag}</span>
        <span className="news-card-views">
          <Eye size={16} />
          {views || 0}
        </span>
        <img
          src={
            imageUrl && imageUrl.trim()
              ? imageUrl.startsWith('http') 
                ? imageUrl 
                : toAbsoluteUrl(imageUrl)
              : defaultThumbnail
          }
          alt={title}
          onError={(e) => (e.currentTarget.src = defaultThumbnail)}
        />
        <div className="image-shadow"></div>
      </div>
      <div className="news-card-content">
        <a 
          href={getDetailPath(slug)}
          onClick={handleLinkClick}
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <h3>{title}</h3>
        </a>
        <p className="news-content">{getPreviewText(content)}</p>
      </div>
    </div>
  );
};

export default NewsCard;
